import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      deviceId: state => state.deviceId,
      mqtt: state => state.mqtt,
    })
  },
  methods: {
    initMqtt (force = false) {
      this.$store.commit('MQTT_DISCONNECT')

      return Promise.resolve(sessionStorage.getItem('mqtt')).then(mqtt => {
        if (mqtt && !force) {
          this.$store.commit('assignValue', {
            mqtt: JSON.parse(mqtt)
          })
          return Promise.resolve()
        } else {
          return this.$http.post('/base/mqtt/token/apply', {
            device_id: this.$store.state.deviceId
          }).then(response => {
            const mqtt = _.get(response.data, 'data')
            this.$store.commit('assignValue', {
              mqtt: mqtt
            })
            sessionStorage.setItem('mqtt', JSON.stringify(mqtt))
          })
        }
      }).then(() => {
        this.$store.commit('MQTT_CONNECT')
        this.$store.commit('MQTT_SUBSCRIBE', `/device`)
        this.$store.commit('MQTT_SUBSCRIBE', `/${this.deviceId}`)
      })
    }
  }
}
